import {
  ToggleCMSProps,
  useCMSToggle,
} from '@/components/atoms/toggle/useCMSToggle';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/decodo/components/atoms/Image/ImageStrapi';
import Popover from '@/decodo/components/atoms/Popover';
import {
  PopupImageLinkInner,
  PopupImageLinkStrapiProps,
} from '@/decodo/components/atoms/PopupImageLink/PopupImageLinkStrapi';

export type TogglePopoverProps = {
  inner?: BlockComponentModel<
    PopupImageLinkStrapiProps,
    PopupImageLinkInner
  >['inner'];
  tab: ToggleCMSProps;
  block: {
    image: ImageStrapiProps;
    popups: ImageStrapiProps[];
  };
};

const TogglePopover = ({ block, inner, tab }: TogglePopoverProps) => {
  const popup = block.popups;

  const { toggleNode, filteredToggleList } = useCMSToggle<typeof popup>(
    popup,
    tab
  );

  return (
    <Popover
      target={<ImageStrapi block={block.image} inner={inner?.image} />}
      showArrow={true}
      position='right'
      {...inner?.popup}
    >
      {tab.toggles.length > 1 && (
        // no need to render a toggle if there is only one tab.
        <div className='mb-1'>{toggleNode?.({ size: 'xs' })}</div>
      )}
      {filteredToggleList?.map((popupItem, index) => (
        <ImageStrapi block={popupItem} inner={inner?.popupImage} key={index} />
      ))}
    </Popover>
  );
};

export default TogglePopover;
